import { forwardRef } from 'react';
import { BaseButton, type BaseButtonProps } from '@/Components/Common/Buttons/BaseButton';
import { cn } from '@/lib/utils';

const DangerButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
    ({ className, ...props }, ref) => {
        return (
            <BaseButton ref={ref} variant="destructive" className={cn(className)} {...props} />
        );
    },
);
DangerButton.displayName = 'DangerButton';

export { DangerButton };
